import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'El Sistema PRO cambió por completo mi forma de trabajar. Las plantillas de evaluación del desempeño ocupacional y los protocolos de intervención me dieron una estructura que necesitaba. Totalmente recomendado para cualquier TO.',
  name: 'María Laura G.',
  role: 'Terapeuta Ocupacional'
}, {
  quote: 'Excelente material. Muy práctico y directo al punto. La sección de adaptación ambiental y tecnología asistiva me ayudó a ampliar mis intervenciones con pacientes geriátricos.',
  name: 'Pablo R.',
  role: 'TO en Centro de Rehabilitación'
}, {
  quote: 'Lo que más valoro es el módulo de pediatría y desarrollo. Tener un paso a paso claro para la intervención temprana me ahorró muchísimas horas de planificación. Una inversión que vale cada centavo.',
  name: 'Sofía M.',
  role: 'Terapeuta Ocupacional Pediátrica'
}];
export function TestimonialsSection() {
  return <section id="testimonios" className="py-10 px-4 bg-warm-beige/30" data-id="element-205">
      <div className="max-w-6xl mx-auto" data-id="element-206">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-207">
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-olive-dark mb-2" data-id="element-208">
            Lo que dicen nuestros <span className="text-golden" data-id="element-209">alumnos</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-210">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-white p-5 rounded-xl shadow-md border border-olive/5 flex flex-col" data-id="element-211">
              <div className="flex gap-0.5 mb-3" data-id="element-212">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-golden text-golden" data-id="element-213" />)}
              </div>
              <p className="text-olive/80 italic mb-4 flex-1 text-sm leading-relaxed" data-id="element-214">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-olive/10" data-id="element-215">
                <div className="w-9 h-9 bg-golden/20 rounded-full flex items-center justify-center text-golden font-bold font-serif text-base" data-id="element-216">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-217">
                  <h4 className="font-bold text-olive-dark text-sm" data-id="element-218">
                    {testimonial.name}
                  </h4>
                  <p className="text-xs text-olive/60" data-id="element-219">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}